import { StarterKit } from '@tiptap/starter-kit'
import { TextStyle } from '@tiptap/extension-text-style'
import { Color, Image } from './extensions'

export const richTextDisplayExtensions = [
  StarterKit.configure({
    blockquote: { HTMLAttributes: { class: 'block-node' } },
    bulletList: { HTMLAttributes: { class: 'list-node' } },
    code: { HTMLAttributes: { class: 'inline', spellcheck: 'false' } },
    codeBlock: false,
    heading: { HTMLAttributes: { class: 'heading-node' } },
    horizontalRule: false,
    link: {
      openOnClick: true,
      HTMLAttributes: { class: 'link' },
    },
    orderedList: { HTMLAttributes: { class: 'list-node' } },
    paragraph: { HTMLAttributes: { class: 'text-node' } },
  }),
  TextStyle,
  Color,
  Image.configure({ allowBase64: true }),
]
